module.exports = __webpack_public_path__ + "img/20.2b6030f3.jpg";